<template>
  <div>
    <!-- área da semana -->
    <!-- área da semana -->
    <div class="container-fluid">
      <div class="row pt-1 pb-3 align-items-center">
        <div class="col-12 col-md-4">
          <h1>Agendamento</h1>
        </div>
        <div class="col-12 col-md-3 d-flex flex-column flex-md-row align-items-center gap-5 justify-content-center">
          <label for="inputdate">Selecione a data:</label>
          <input type="date" name="inputdate" id="inputdate" v-model="inputdate" :max="maxDate" :min="minDate">
        </div>

        <div
          class="col-12 col-md-5 text-center d-flex flex-column flex-md-row align-items-center justify-content-center gap-2">
          Legenda: <span class="btn btn-danger">esgotado</span>
          <span class="btn btn-secondary" style="opacity:.6">inativo</span>
          <span class="btn btn-success">disponivel</span>
        </div>
      </div>
      <div class="row my-4">
        <div class="col-12 d-flex flex-column align-items-center gap-5 justify-content-center">
        <label for="consulta">
          Logado como: <b>{{ emails }}</b>
        </label>
        <input class="w-50 d-none" id="consulta" type="text" v-model="emails" readonly />
      </div>
      </div>
    </div>
    <div class="semana-calendario my-5 px-5">


      <!-- laço de repetição dos quadros de dias da semana selecionada -->
      <div class="dia d-flex flex-column border border-secondary p-5" v-for="(dia, index) in diasDaSemana" :key="index"
        :class="{ 'indisponivel': encontrarStatus(dia.bruta2) === '0' }">
        <!-- modal condicionado -->

        <ModalForm  :isVisible="isModalVisible" :codigodisplay="codigo" @close="isModalVisible = false"
          @submit="handleFormSubmit" />

    
        <!-- modal condicionado -->
        <div>{{ dia.dataf }}</div>
        <div>{{ dia.nome }}</div>
        <div v-if="encontrarStatus(dia.bruta2) === '0'">
          <mark>
           Agenda não aberta.
          </mark>
        </div>

        <hr />
        <div class="d-flex justify-content-between flex-column flex-grow-1 px-3">
          <div class="horario-tabs d-flex justify-content-center gap-5 my-4 px-3">
            <button class="btn btn-secondary" :class="{ 'btn-ativo': horarioAtivo === '8h 30min' }"
              @click="horarioAtivo = '8h 30min'">
              8h30
            </button>
            <button class="btn btn-secondary" :class="{ 'btn-ativo': horarioAtivo === '10h 30min' }"
              @click="horarioAtivo = '10h 30min'">
              10h30
            </button>
            <button class="btn btn-secondary" :class="{ 'btn-ativo': horarioAtivo === '13h 00min' }"
              @click="horarioAtivo = '13h 00min'">
              13h00
            </button>
            <button class="btn btn-secondary" :class="{ 'btn-ativo': horarioAtivo === '15h 00min' }"
              @click="horarioAtivo = '15h 00min'">
              15h00
            </button>
          </div>


          <div class="locus-horario">

            <span v-if="dia.dataf === '14/02/2024'">Museu Fechado</span>
            <div v-if="horarioAtivo === '8h 30min'" class="bloco-roteiros row">
              <BotaoRoteiro @estadoRoteiro="abrirModal" :condicaoferiado="dia.nome" :condicaoferiado2="dia.dataf"
                :ids-indisponiveis="idsIndisponiveis" :statusdia="encontrarStatus(dia.bruta2)" :propsemana="dia.nome"
                v-for="numero in numeroMaximo(dia.nome)" :key="numero"
                :prophorario="modificarProphorario(`${dia.bruta}083000${numero.toString().padStart(2, '0')}`, dia.nome)"
                :propdate="dia.data" :prophoje="hojef" :texto="`R${numero}`" />
            </div>
          </div>
          <div>

            <span v-if="dia.dataf === '14/02/2024'">Museu Fechado</span>
            <div v-if="horarioAtivo === '10h 30min'" class="bloco-roteiros row">
              <BotaoRoteiro @estadoRoteiro="abrirModal" :condicaoferiado="dia.nome" :condicaoferiado2="dia.dataf"
                :ids-indisponiveis="idsIndisponiveis" :statusdia="encontrarStatus(dia.bruta2)" :propsemana="dia.nome"
                v-for="numero in numeroMaximo(dia.nome)" :key="numero"
                :prophorario="modificarProphorario(`${dia.bruta}103000${numero.toString().padStart(2, '0')}`, dia.nome)"
                :propdate="dia.data" :prophoje="hojef" :texto="`R${numero}`" />
            </div>
          </div>
          <div>


            <div v-if="horarioAtivo === '13h 00min'" class="bloco-roteiros row">
              <BotaoRoteiro @estadoRoteiro="abrirModal" :condicaoferiado="dia.nome" :condicaoferiado2="dia.dataf"
                :ids-indisponiveis="idsIndisponiveis" :statusdia="encontrarStatus(dia.bruta2)" :propsemana="dia.nome"
                v-for="numero in numeroMaximo(dia.nome)" :key="numero"
                :prophorario="modificarProphorario(`${dia.bruta}130000${numero.toString().padStart(2, '0')}`, dia.nome)"
                :propdate="dia.data" :prophoje="hojef" :texto="`R${numero}`" />
            </div>
          </div>
          <div>


            <div v-if="horarioAtivo === '15h 00min'" class="bloco-roteiros row">
              <BotaoRoteiro @estadoRoteiro="abrirModal" :condicaoferiado="dia.nome" :condicaoferiado2="dia.dataf"
                :ids-indisponiveis="idsIndisponiveis" :statusdia="encontrarStatus(dia.bruta2)" :propsemana="dia.nome"
                v-for="numero in numeroMaximo(dia.nome)" :key="numero"
                :prophorario="modificarProphorario(`${dia.bruta}150000${numero.toString().padStart(2, '0')}`, dia.nome)"
                :propdate="dia.data" :prophoje="hojef" :texto="`R${numero}`" />
            </div>
          </div>
        </div>
      </div>
      <!-- laço de repetição dos quadros de dias da semana selecionada -->
    </div>

    <!-- área da semana -->
    <!-- Legendas -->

    <!-- Legendas -->
  </div>
</template>

<script>
import axios from "axios";
import { ref, watchEffect, watch, computed, onMounted } from "vue";
import ModalForm from "../components/ModalForm.vue"; // Certifique-se de que o caminho está correto.
import BotaoRoteiro from "../components/BotaoRoteiro.vue";
import { getCurrentUser } from "@/services/authService"; // user

// tudo acima são os imports
export default {
  components: {
    ModalForm,
    BotaoRoteiro,
  },
  // é a nova forma de escrever: api vue ou vue 3 com setup.
  setup() {
    const horarioAtivo = ref('8h 30min'); // Estado inicial é 8h30
    const emails = localStorage.getItem('userEmail'); // Certifique-se que isto retorna o e-mail correto
    const numeroMaximo = (nomeDoDia) => {
      const diasCom14 = ['terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado', 'domingo'];
    //  if (inputdate.value >= "2024-03-01" && inputdate.value < "2024-04-25") {
      //  return diasCom14.includes(nomeDoDia.toLowerCase()) ? 16 : 15;
      //}
      //else {
        return diasCom14.includes(nomeDoDia.toLowerCase()) ? 16 : 15;
      //}
    };
    // Outras definições omitidas para brevidade...
    const isAdministrator = computed(() => getCurrentUser() === 'admin.agendamento@cataventomaster.com');
    const inputdate = ref('');

    // Atualiza a data mínima e a data inicial no carregamento do componente
    onMounted(() => {
      const today = new Date();
      if (!isAdministrator.value) {
        today.setDate(today.getDate() + 7);
      } else {
        // Ajuste conforme necessário para administradores
      }
      inputdate.value = today.toISOString().substring(0, 10);
    });

    // Atualiza inputdate baseado em alguma lógica específica, se necessário
    watch(isAdministrator, (newValue) => {
      const today = new Date();
      if (!newValue) {
        today.setDate(today.getDate() + 7);
      } else {
        // Ajuste conforme necessário para administradores
      }
      inputdate.value = today.toISOString().substring(0, 10);
    });

    // Definições de minDate e maxDate mantêm-se iguais
    const minDate = computed(() => {
      const today = new Date();
      if (!isAdministrator.value) {
        today.setDate(today.getDate() + 8);
      }
      return today.toISOString().split('T')[0];
    });
    const ultimoDiaStatus1 = ref(null);
    const maxDate = computed(() => {
      if (!isAdministrator.value) {
      return encontrarUltimoDiaStatus1();
      }else{
        return null;
      }
    });
    const encontrarUltimoDiaStatus1 = () => {
  for (let i = calendarioData.value.length - 1; i >= 0; i--) {
    if (calendarioData.value[i].status == '1') {
      ultimoDiaStatus1.value = calendarioData.value[i].dia;
      return ultimoDiaStatus1.value; // Retorna o último dia com status '1'
    }
  }
  // Caso nenhum dia com status '1' seja encontrado, podemos retornar uma data padrão ou null
  return null;
};

    const mostrarBotaoAnterior = ref(true);
    const mostrarBotaoProximo = ref(true);
    const idsIndisponiveis = ref([]);

    const calendarioData = ref([]);

    const fetchData = async () => {
      try {
        const response = await axios.get('https://museucatavento.org.br/sistema-agendamento/api5.php');
        calendarioData.value = response.data;
        console.log(calendarioData.value);
      } catch (error) {
        console.error("Erro ao buscar dados: ", error);
      }
    };

    const encontrarStatus = (data) => {
      if (getCurrentUser() != 'admin.agendamento@cataventomaster.com') {
        const item = calendarioData.value.find(item => item.dia === data);
        return item ? item.status : null; // Retorna o status se encontrar, senão retorna null
      } else {
        return '1';
      }
    };

    const carregarIdsIndisponiveis = async () => {
      try {
        const response = await axios.get(
          "https://museucatavento.org.br/sistema-agendamento/api.php"
        );
        idsIndisponiveis.value = response.data.map((item) => item.id);
        console.log("IDS indisponiveis :"+ idsIndisponiveis.value );
        
      } catch (error) {
        console.error("Erro ao carregar os IDs indisponíveis:", error);
      }
    };
    const modificarProphorario = (prophorario) => {
            return prophorario;
    };
    onMounted(() => {
      carregarIdsIndisponiveis();
      fetchData();

    }
    );

    const isModalVisible = ref(false); // variavel do modal
    const hoje = ref(new Date()); // traz o dia de hoje
    const diasDaSemana = ref([]); // array de dias da semana
    const hojef = ref("");
    const codigo = ref("");
    const isHoje = (data) => {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0); // Zera a hora, minuto, segundo e milissegundo
      const dataComparar = new Date(data);
      dataComparar.setHours(0, 0, 0, 0);
      return dataComparar.getTime() === hoje.getTime();
    };

    const abrirModal = (dados) => {
      codigo.value = dados.codigoin;
      isModalVisible.value = true;
      console.log("Este é o ID que está sendo reservado: "+codigo.value);
    };
    const handleFormSubmit = (formData) => {
      console.log(formData);
    };


    watchEffect(() => {
      let inicioSemana = new Date(inputdate.value + 'T00:00:00-03:00');

      // aqui ele retorna sempre ao domingo, subtraindo o dia do mês pelo dia posição semana
      diasDaSemana.value = Array.from({ length: 1 }).map((_, i) => {
        let dia = new Date(inicioSemana);
        dia.setDate(dia.getDate() + i);
        hojef.value = new Date();
        return {
          data: new Date(dia),
          dataf: dia.toLocaleDateString(),
          nome: dia.toLocaleDateString("pt-BR", { weekday: "long" }),
          bruta: `${dia.getFullYear()}${(dia.getMonth() + 1)
            .toString()
            .padStart(2, "0")}${dia.getDate().toString().padStart(2, "0")}`,
          bruta2: `${dia.getFullYear()}-${(dia.getMonth() + 1)
            .toString()
            .padStart(2, "0")}-${dia.getDate().toString().padStart(2, "0")}`,
        };
      }); // preenche os dias da semana, partindo do domingo, como dia inicial.
      // Definir datas limites
      const umaSemanaAtras = new Date();
      umaSemanaAtras.setDate(umaSemanaAtras.getDate() - 7);
      const seisSemanasFrente = new Date();
      if (getCurrentUser() == "admin.agendamento@cataventomaster.com") {
        seisSemanasFrente.setDate(seisSemanasFrente.getDate() + 200);
      } else {
        seisSemanasFrente.setDate(seisSemanasFrente.getDate() + 42);
      }
      // Atualizar visibilidade dos botões
      mostrarBotaoAnterior.value = inicioSemana > umaSemanaAtras;
      mostrarBotaoProximo.value = inicioSemana < seisSemanasFrente;
    });

    return {
      mostrarBotaoAnterior,
      mostrarBotaoProximo,
      calendarioData,
      idsIndisponiveis,
      emails,
      codigo,
      hoje,
      hojef,
      numeroMaximo,
      isHoje,
      minDate,
      horarioAtivo,
      maxDate,
      modificarProphorario,
      isModalVisible,
      diasDaSemana,
      inputdate,
      abrirModal,
      encontrarStatus,
      handleFormSubmit,
      encontrarUltimoDiaStatus1
    };
  },
};
</script>

<style lang="scss" scoped>
span.btn {
  cursor: not-allowed !important;
}

.semanas-btn {
  button {
    font-size: 14px;
  }
}

.semana-calendario {
  display: flex;
  justify-content: space-around;
  align-items: start;
  width: 100%;

  margin-left: auto;
  margin-right: auto;

  .dia {
    margin: 0;
    text-align: center;
    height: inherit;
    flex-grow: 1;
    background: var(--catavento-surface, #fff);
    border-radius: var(--catavento-radius, 8px);
    box-shadow: var(--catavento-shadow, 0 10px 28px rgba(20, 30, 45, 0.12));
    border-color: var(--catavento-border, #d9e1ea) !important;

    &.indisponivel {
      background-color: #f0f2f4;
    }

    .horario {
      margin-bottom: 5px;
      margin-top: 5px;
      display: flex;
      justify-content: center;
      font-weight: bold;
    }

    .bloco-roteiros {
      flex-direction: column;
      gap: 0.75rem;

      @media(min-width: 1200px){
        flex-direction: row;
      }


      .roteiros {
        padding: 0.6rem;
        margin-top: 2px;
        margin-right: 2px;
        display: flex;
        width: 100%;
        min-height: 112px;

        @media(min-width: 1200px) {

          width: 15%;
        }

        border: 1px solid var(--catavento-border, #d9e1ea);

        &:hover {
          filter: brightness(0.95);
        }
      }
    }
  }
}

.btn-ativo {
  background-color: var(--catavento-blue, #165a96) !important;
  color: white;
  border-color: var(--catavento-blue, #165a96) !important;
}

.horario-tabs {
  flex-wrap: wrap;
  gap: 0.75rem !important;
}

@media (max-width: 767px) {
  .semana-calendario {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    margin-top: 1.5rem !important;
  }

  .semana-calendario .dia {
    padding: 1.25rem !important;
  }
}

</style>
